import { ReactComponent } from './charging-station-xl.svg';
export const ChargingStationIconXl = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=charging-station-xl.js.map